import { Link } from "react-router-dom";
import { Phone, Truck } from "lucide-react";
import { useAuth, homeFor } from "@/context/AuthContext";
import { ui } from "@/lib/ui";

const NAV = [
  { href: "#services", label: "What we do", testId: "nav-services-link" },
  { href: "#coverage", label: "Coverage", testId: "nav-coverage-link" },
  { href: "#pricing", label: "Pricing", testId: "nav-pricing-link" },
  { href: "#leadership", label: "Leadership", testId: "nav-leadership-link" },
];

export const SiteHeader = ({ profile }) => {
  const { user } = useAuth();
  return (
    <header data-testid="site-header" className="sticky top-0 z-40 backdrop-blur-xl bg-[#030712]/80 border-b border-cyan-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2.5 min-w-0" data-testid="nav-home-link">
          <span className="grid place-items-center w-9 h-9 border glow-cyan text-cyan-300 shrink-0"><Truck className="w-4 h-4" /></span>
          <span className="font-display font-bold text-sm sm:text-base tracking-widest uppercase truncate">{profile.company_name}</span>
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} data-testid={n.testId} className="font-mono text-xs uppercase tracking-[0.18em] text-slate-400 hover:text-cyan-300 transition-colors">{n.label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          {profile.phone && (
            <a href={`tel:${profile.phone}`} data-testid="header-phone-link" className="hidden md:flex items-center gap-2 font-mono text-sm text-[#00FF66] text-glow-green">
              <Phone className="w-4 h-4" />{profile.phone}
            </a>
          )}
          {user ? (
            <Link to={homeFor(user)} data-testid="nav-customer-portal-link" className={`${ui.btnSecondary} px-3 py-2 text-xs`}>
              {user.role === "customer" ? "My portal" : "Dashboard"}
            </Link>
          ) : (
            <Link to="/login" data-testid="customer-login-link" className={`${ui.btnSecondary} px-3 py-2 text-xs`}>Sign in</Link>
          )}
        </div>
      </div>
    </header>
  );
};
